<template>
  <section>
    <ServicesTopBar />
    <Favorite />
    <SiteFooter />
  </section>
</template>

<script>
import ServicesTopBar from '../components/services/ServicesTopBar.vue'
import Favorite from '../components/services/Favorates.vue'
import SiteFooter from '../components/site/SiteFooter.vue'

export default {
  components: { ServicesTopBar, Favorite, SiteFooter },
}
</script>

<style scoped>

</style>
